import React, { useMemo } from 'react';
import { FormikValues } from 'formik';
import { TextField } from '@mui/material';
import { usePasswordHideShow } from 'components/Input/hooks';
import { TextFieldProps } from '@mui/material/TextField/TextField';

import useStyles from './styles';

interface IProps {
  name: string;
  formik: FormikValues;
  helperInfoText?: string;
}

const Input: React.FC<IProps & TextFieldProps> = ({
  label,
  placeholder,
  name,
  formik,
  type = 'text',
  disabled,
  minRows = 0,
  size,
  maxRows,
  helperInfoText,
  ...restProps
}) => {
  const { isPasswordInput, icons, openPassword } = usePasswordHideShow({ type });

  const classes = useStyles();

  const helperText = useMemo(
    () =>
      (formik.errors[name] && formik.touched[name]) || helperInfoText ? (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>{formik.errors[name] ?? ''}</div>
          <div className={classes.infoText}>{helperInfoText}</div>
        </div>
      ) : undefined,
    [formik.errors[name], helperInfoText],
  );

  return (
    <TextField
      className={classes.container}
      label={label}
      variant="outlined"
      placeholder={placeholder}
      fullWidth
      id={name}
      name={name}
      value={formik.values[name]}
      onChange={formik.handleChange}
      onBlur={formik.handleBlur}
      helperText={helperText}
      error={!!(formik.errors[name] && formik.touched[name])}
      type={openPassword ? 'text' : type}
      disabled={disabled}
      multiline={!!minRows}
      minRows={minRows}
      InputProps={{
        endAdornment: isPasswordInput ? icons : undefined,
      }}
      autoComplete="on"
      size={size}
      maxRows={maxRows}
      {...restProps}
    />
  );
};

export default Input;
